import { t } from "../../utils/i18n";
import React from "react";

const Actions = ({
  canSubmitTransfer,
  transferId,
  invalidTransfer,
  cancelTransfer,
  destinationAmount,
  submitting,
  submitTransfer,
  submitTransferPreview,
  refreshPage
}) => (
  <div className="form-actions">
    {canSubmitTransfer && transferId ? (
      <div className="mr-auto">
        <div className="col-md-6 float-md-right pr-0">
          <button
            name="button"
            type="submit"
            className="btn btn-primary pull-right ml-4 mb-4"
            onClick={e => submitTransfer(e)}
            disabled={invalidTransfer}
          >
            {t("transfers_send.common.submit")}
          </button>
        </div>
        <div className="col-md-6 float-md-left pl-0">
          <button
            name="cancel"
            type="submit"
            className="btn pull-left ml-4 mb-4"
            onClick={e => cancelTransfer(e)}
          >
            {t("transfers_send.common.cancel")}
          </button>
        </div>
      </div>
    ) : (
      <div className="mr-auto">
        <div className="col-md-6 float-md-right pr-0">
          <button
            name="button"
            type="submit"
            className="btn btn-primary pull-right mb-2 col-xs-4"
            onClick={e => submitTransferPreview(e)}
            disabled={invalidTransfer || submitting}
          >
            {submitting ? (
              <>
                <i className="fa fa-circle-o-notch fa-spin"></i>
                <span style={{ paddingLeft: "5px" }}>
                  {t("transfers_send.common.please_wait")}
                </span>
              </>
            ) : (
              <span>{t("transfers_send.common.preview_transfer")}</span>
            )}
          </button>
        </div>
        <div className="col-md-6 float-md-left pl-0">
          <button
            name="start_again"
            type="submit"
            className="btn pull-left mb-2"
            onClick={e => refreshPage(e)}
          >
            {t("transfers_send.common.start_again")}
          </button>
        </div>
      </div>
    )}
  </div>
);

export default Actions;
